import gql from 'graphql-tag';

export default gql`
  query getMemberWallet($loyaltyId: String) {
    memberWallet(loyaltyId: $loyaltyId) {
      memberWalletOffers {
        type
        title
        expiry_date
        short_description
        short_description_cta
        description
        subheading
        legal_text
        long_description
        crm_code
        personalized_offer
        image {
          url
        }
        details_image {
          url
        }
        offer_id
        cta_1 {
          title
          href
        }
        cta_2 {
          title
          href
        }
      }
    }
  }
`;
